export default [
  {
    path: '/settlement-instructions/:key?',
    name: 'settlement-instructions',
    component: () => import('@/views/settlementInstructions/SettlementInstructionsMain.vue'),
    meta: {},
  },
];
